import React from 'react';
import { Clock3Icon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  onDark?: boolean;
};
export function Countdown({
  onDark = false
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Minutes'
  }, {
    value: seconds,
    label: 'Seconds'
  }];
  return <div className="mt-7 text-center" role="timer" aria-live="off" data-id="element-80" data-mp="3c13216hsi5m9">
      <p className={`flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wider ${onDark ? 'text-white' : 'text-alarm'}`} data-id="element-81" data-mp="3h1idfsiih31l">
        <Clock3Icon className="h-4 w-4" aria-hidden="true" data-id="element-82" data-mp="372t6gus5l304" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" data-id="element-83" data-mp="10cl8mayi7q68">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-84" data-mp="15by57nf6gbm0" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-85" data-mp="15an45vd49hyl">
              <span className="flex h-[68px] w-[68px] items-center justify-center rounded-xl bg-brand-deep font-serif text-[34px] font-bold tabular-nums text-white shadow-card sm:h-20 sm:w-20 sm:text-4xl" data-id="element-86" data-mp="y0eoxy4k85zw">
                {String(unit.value).padStart(2, '0')}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${onDark ? 'text-white/70' : 'text-muted'}`} data-id="element-87" data-mp="12s54qjm9nlyp">
                {unit.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-3xl font-bold ${onDark ? 'text-white' : 'text-brand-deep'}`} data-id="element-88" data-mp="a4iyt4pkg58o">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}